import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export const getIsShadowMailbox = () => getUserConfiguration().SessionSettings?.IsShadowMailbox;
